import { Component } from '@angular/core';
import { BaseButtonComponent } from './base-button.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sibat-validate-button',
  template: `
    <button
      mat-button
      class="button button-green"
      [type]="submit ? 'submit' : 'button'"
      [class.button-disabled]="disabled"
      [class.button-stretch]="stretch"
      [disabled]="disabled"
      (click)="clicked.emit($event)"
    >
      @if (icon) {
      <mat-icon>{{ icon }}</mat-icon>
      }
      <span>{{ label }}</span>
    </button>
  `,
  styleUrls: ['buttons.scss'],
  imports: [MatButton, MatIcon],
})
export class ValidateButtonComponent extends BaseButtonComponent {}
